import { version } from '../../package.json';

export const VERSION = version;
export const PROJECT_NAME = 'GreenPharm IS';
